import { OrganisationSettingVM } from '../../../apollo/queries/organisations/organisationSetting.queries';
import { SettingCategory, SettingCode } from '../types';
import { ContentRepository } from '../../../apollo/queries/organisations/contentRepositores.queries';
import {
  CONTENT_REPOSITORY,
  CONTENT_REPOSITORY_TOOLTIP_TEXT,
} from '../../../utils/constants';

export type OrganisationSettingMap = Map<
  SettingCategory,
  OrganisationSettingVM[]
>;

const useSettingsVM = (
  contentRepositories: ContentRepository[],
): OrganisationSettingMap => {
  const allSettings = new Map<SettingCategory, OrganisationSettingVM[]>();

  allSettings.set(SettingCategory.contentManagement, [
    {
      settingCode: SettingCode.contentRepository,
      category: SettingCategory.contentManagement,
      enabled: false,
      name: CONTENT_REPOSITORY,
      value: contentRepositories,
      description: CONTENT_REPOSITORY_TOOLTIP_TEXT,
    },
  ]);

  return allSettings;
};

export default useSettingsVM;
